export default "__VITE_ASSET__CQLZPvzO__"